import { RootStore } from '~/stores/root.store';
import fetchJsonp from 'fetch-jsonp';

const HONEYBOOK_APPLE_APP_ID = '1104772757';
const APPLE_LOOKUP_API_URL = 'https://itunes.apple.com/lookup?id=';

export interface IAppleRatingResponse {
    averageUserRating: number;
    userRatingCount: number;
}

export const DEFAULT_USER_RATING_COUNT = 3000;
export const DEFAULT_AVERAGE_USER_RATING = 5;

export class AppleService {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    async getAppRatingData(): Promise<IAppleRatingResponse> {
        const { fullstoryService } = this.rootStore;

        return fetchJsonp(`${APPLE_LOOKUP_API_URL}${HONEYBOOK_APPLE_APP_ID}`)
            .then(response => {
                return response.json();
            })
            .then(json => {
                const results = json.results;
                const resultCount = json.resultCount;
                if (resultCount > 0) {
                    const {
                        averageUserRating = DEFAULT_AVERAGE_USER_RATING,
                        userRatingCount = DEFAULT_USER_RATING_COUNT
                    } = results[0];
                    return { averageUserRating, userRatingCount };
                }
            })
            .catch(error => {
                fullstoryService.error(
                    `Failed to get app ratings from apple. Message: ${error.message}`
                );
                return {
                    averageUserRating: DEFAULT_AVERAGE_USER_RATING,
                    userRatingCount: DEFAULT_USER_RATING_COUNT
                };
            });
    }
}
